import React from "react";
import { Button, Modal } from "semantic-ui-react";
import { ObjectReference } from "../../helpers/TablePageUtils";
import { textLabels } from "../../consts/textLabels";
import styles from "./commonStyles/table.module.css";

interface Props {
    items?: ObjectReference[];
    confirmLabel: string;
    onConfirm: () => void;
    onClose: () => void;
}

const MAX_NAMES_TO_SHOW = 10;

const ConfirmDeleteModal: React.FC<Props> = ({ items, confirmLabel, onConfirm, onClose }) => {
    const isOpen = !!items && items.length > 0;
    const count = items?.length ?? 0;
    const names = items?.map(i => i.name) ?? [];

    return (
        <Modal open={isOpen} onClose={onClose} closeIcon>
            <Modal.Header className={styles.modalHeader}>
                {count === 1
                    ? `${confirmLabel} ${items![0].name}?`
                    : `${confirmLabel} (${count} шт.)?`
                }
            </Modal.Header>
            {count > 1 && (
                <Modal.Content>
                    <p>Будут удалены:</p>
                    <ul style={{ paddingLeft: "20px", margin: 0 }}>
                        {names.slice(0, MAX_NAMES_TO_SHOW).map((name, i) => (
                            <li key={i}>{name}</li>
                        ))}
                        {count > MAX_NAMES_TO_SHOW && (
                            <li>другие в количестве {count - MAX_NAMES_TO_SHOW} шт.</li>
                        )}
                    </ul>
                </Modal.Content>
            )}
            <Modal.Actions>
                <Button content={textLabels.deleteButton.toUpperCase()} onClick={onConfirm} negative />
                <Button color="grey" onClick={onClose}>
                    {textLabels.cancelButton}
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default ConfirmDeleteModal;
